import { z } from 'zod';

// The MCP method-dispatch endpoint (IMM-522.2) speaks JSON-RPC 2.0, so its
// body is one loose envelope rather than a per-operation schema — the leaf is
// the deliberate exception to the one-leaf-per-operation rule. `params` stays
// passthrough: tool arguments are validated by the tool's own Zod schema, and
// the protocol's `_meta` rides inside it. `id` is OPTIONAL: a JSON-RPC
// notification (the legacy handshake's `notifications/initialized`, IMM-684.1)
// carries none, and it must reach the route — which answers it `202` after
// authentication — rather than die in schema validation before the credential
// resolves.
export const McpJsonRpcRequestSchema = z.object({
  jsonrpc: z.literal('2.0'),
  id: z.union([z.string(), z.number(), z.null()]).optional(),
  method: z.string().min(1),
  params: z.looseObject({}).optional(),
});

export const McpJsonRpcResponseSchema = z.looseObject({
  jsonrpc: z.literal('2.0'),
  id: z.union([z.string(), z.number(), z.null()]),
});

export type McpJsonRpcRequest = z.infer<typeof McpJsonRpcRequestSchema>;
export type McpJsonRpcResponse = z.infer<typeof McpJsonRpcResponseSchema>;
